import { Outlet, useOutletContext } from "react-router";

import { Stack } from "@mui/material";
import { AssetInventoryNavigation, AssetInventoryNoticeBox, ClientTabBase } from "@shared";

import { ClientDetailResponse } from "@/api";
import { ClientStatusWidget } from "@/pages/clients/client/components/client-status-widget/ClientStatusWidget";

export function AssetInventoryTab() {
  const client = useOutletContext<ClientDetailResponse>();

  return (
    <Stack gap={2} flex={1} overflow="hidden">
      <AssetInventoryNoticeBox />
      <ClientTabBase
        navigation={<AssetInventoryNavigation />}
        navigationFooter={<ClientStatusWidget client={client} />}
      >
        <Outlet context={client} />
      </ClientTabBase>
    </Stack>
  );
}
